var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-field-label"},[_c('span',[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"form-description-area"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.description_area_content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }